export enum YandexMetrikaEvent {
  MAIN_LOGOUT = 'MAIN_LOGOUT',
  MAIN_PROJECT_СHANGE = 'MAIN_PROJECT_СHANGE',
  MAIN_TOTAL_COMMUNAL = 'MAIN_TOTAL_COMMUNAL',
  MAIN_TOTAL_CAPITAL = 'MAIN_TOTAL_CAPITAL',
  MAIN_PROFILE = 'MAIN_PROFILE',
  MAIN_CONTACTS = 'MAIN_CONTACTS',
  MAIN_PROJECTS = 'MAIN_PROJECTS',
  MAIN_ACCESS = 'MAIN_ACCESS',
  MAIN_NOTIFICATIONS = 'MAIN_NOTIFICATIONS',
  MAIN_COUNTERS_LIST = 'MAIN_COUNTERS_LIST',
  MAIN_PROPOSAL_DETAIL = 'MAIN_PROPOSAL_DETAIL',
  MAIN_PAY_INVOICES = 'MAIN_PAY_INVOICES',
  MAIN_PAY_BALANCES = 'MAIN_PAY_BALANCES',
  MAIN_NEWS_DETAIL = 'MAIN_NEWS_DETAIL',
  MAIN_FEED = 'MAIN_FEED',
  MAIN_NEW_REQUESTS_REPLAY = 'MAIN_NEW_REQUESTS_REPLAY',
  MAIN_PASSES_REPLAY = 'MAIN_PASSES_REPLAY',
  MAIN_PASSES_OPEN = 'MAIN_PASSES_OPEN',
  MAIN_NEW_REQUESTS_OPEN = 'MAIN_NEW_REQUESTS_OPEN',

  ACTS_OPEN_FILTERS = 'ACTS_OPEN_FILTERS',
  ACTS_APPLY_FILTERS = 'ACTS_APPLY_FILTERS',

  INVOICES_TOTAL_COMMUNAL = 'INVOICES_TOTAL_COMMUNAL',
  INVOICES_TOTAL_CAPITAL = 'INVOICES_TOTAL_CAPITAL',
  INVOICES_QUICK_FILTERS = 'INVOICES_QUICK_FILTERS',
  INVOICES_OPEN_FILTERS = 'INVOICES_OPEN_FILTERS',
  INVOICES_APPLY_FILTERS = 'INVOICES_APPLY_FILTERS',
  INVOICE_PAYMENT = 'INVOICE_PAYMENT',
  INVOICES_VIEW_DOC = 'INVOICES_VIEW_DOC',

  COUNTERS_POST_READINGS = 'COUNTERS_POST_READINGS',
  COUNTERS_HISTORY = 'COUNTERS_HISTORY',

  FEED_NEWS_DETAIL = 'FEED_NEWS_DETAIL',
  FEED_PROPOSAL_DETAIL = 'FEED_PROPOSAL_DETAIL',

  MENU_GOOGLEPLAY = 'MENU_GOOGLEPLAY',
  MENU_APPSTORE = 'MENU_APPSTORE',
  MENU_RUSTORE = 'MENU_RUSTORE',

  CAMERAS_QUICK_FILTERS = 'CAMERAS_QUICK_FILTERS',
  CAMERAS_VIEW_OPEN = 'CAMERAS_VIEW_OPEN',
  CAMERAS_VIEW_OPEN_NA = 'CAMERAS_VIEW_OPEN_NA',

  INV2_PREM_FILTERS = 'INV2_PREM_FILTERS',
  INV2_TYPES_FILTERS = 'INV2_TYPES_FILTERS',
  INV2_PAY_INVOICES_ALL = 'INV2_PAY_INVOICES_ALL',
  INV2_PAY_INVOICES_PREM = 'INV2_PAY_INVOICES_PREM',
  INV2_PAY_BALANCES_ALL = 'INV2_PAY_BALANCES_ALL',
  INV2_PAY_BALANCES_PREM = 'INV2_PAY_BALANCES_PREM',
  INV2_PAY_TOTAL_CLICK = 'INV2_PAY_TOTAL_CLICK',
  INV2_PAY_BALANCE_CLICK = 'INV2_PAY_BALANCE_CLICK',
  INV2_PAY_PREPAY_CLICK = 'INV2_PAY_PREPAY_CLICK',
  INV2_OPEN_CALENDAR = 'INV2_OPEN_CALENDAR',
  INV2_VIEW_DOC = 'INV2_VIEW_DOC',

  PASSES_QUICK_FILTERS = 'PASSES_QUICK_FILTERS',
  PASSES_OPEN_FILTERS = 'PASSES_OPEN_FILTERS',
  PASSES_APPLY_FILTERS = 'PASSES_APPLY_FILTERS',
  PASSES_REPLAY = 'PASSES_REPLAY',
  PASSES_CREATE = 'PASSES_CREATE',
  PASSES_POST = 'PASSES_POST',
  PASSES_CANCEL_CALL = 'PASSES_CANCEL_CALL',
  PASSES_PAYMENT_BUTTON = 'PASSES_PAYMENT_BUTTON',
  PASSES_FEEDBACK_BUTTON = 'PASSES_FEEDBACK_BUTTON',
  PASSES_EDIT_AUTO_START = 'PASSES_EDIT_AUTO_START',
  PASSES_EDIT_AUTO_END = 'PASSES_EDIT_AUTO_END',

  PASSES_RENT_CREATE = 'PASSES_RENT_CREATE',
  PASSES_RENT_QUICK_FILTERS_HOURS = 'PASSES_RENT_QUICK_FILTERS_HOURS',
  PASSES_RENT_QUICK_FILTERS_DAYS = 'PASSES_RENT_QUICK_FILTERS_DAYS',
  PASSES_RENT_OPEN_CALENDAR_HOURS = 'PASSES_RENT_OPEN_CALENDAR_HOURS',
  PASSES_RENT_OPEN_CALENDAR_DAYS = 'PASSES_RENT_OPEN_CALENDAR_DAYS',
  PASSES_RENT_APPLY_CALENDAR_HOURS = 'PASSES_RENT_APPLY_CALENDAR_HOURS',
  PASSES_RENT_APPLY_CALENDAR_DAYS = 'PASSES_RENT_APPLY_CALENDAR_DAYS',
  PASSES_RENT_CALCULATE = 'PASSES_RENT_CALCULATE',
  PASSES_RENT_PAY = 'PASSES_RENT_PAY',

  NEW_REQUEST_QUICK_FILTERS = 'NEW_REQUEST_QUICK_FILTERS',
  NEW_REQUEST_OPEN_FILTERS = 'NEW_REQUEST_OPEN_FILTERS',
  NEW_REQUEST_APPLY_FILTERS = 'NEW_REQUEST_APPLY_FILTERS',
  NEW_REQUEST_REPLAY = 'NEW_REQUEST_REPLAY',
  NEW_REQUEST_CREATE = 'NEW_REQUEST_CREATE',
  NEW_REQUEST_POST = 'NEW_REQUEST_POST',
  NEW_REQUEST_CANCEL_CALL = 'NEW_REQUEST_CANCEL_CALL',
  NEW_REQUEST_PAYMENT_BUTTON = 'NEW_REQUEST_PAYMENT_BUTTON',
  NEW_REQUEST_FEEDBACK_BUTTON = 'NEW_REQUEST_FEEDBACK_BUTTON',
  PASSES_CANCEL = 'PASSES_CANCEL',

  INV2_PAY_DEBT_LESS = 'INV2_PAY_DEBT_LESS',
  INV2_PAY_DEBT_MORE = 'INV2_PAY_DEBT_MORE',
  INV2_PAY_DEBT_EQUAL = 'INV2_PAY_DEBT_EQUAL',

  CONTACTS_CREATE_START = 'CONTACTS_CREATE_START',
  CONTACTS_CREATE_FINISH = 'CONTACTS_CREATE_FINISH',
  CONTACTS_DELETE = 'CONTACTS_DELETE',
  CONTACTS_VIEW = 'CONTACTS_VIEW',
  CONTACTS_REPEAT = 'CONTACTS_REPEAT',

  INVITES_DELETE = 'INVITES_DELETE',
  INVITES_VIEW = 'INVITES_VIEW',

  STORIES_BUTTON = 'STORIES_BUTTON',

  INFO_VIEW_DOC = 'INFO_VIEW_DOC',

  MY_AUTO_LIST = 'MY_AUTO_LIST',
  MY_AUTO_ADD = 'MY_AUTO_ADD',
  MY_AUTO_EDIT = 'MY_AUTO_EDIT',
  MY_AUTO_DELETE = 'MY_AUTO_DELETE',
  MY_AUTO_ORDER = 'MY_AUTO_ORDER',

  PASSES_AUTO_QUICK_ADD = 'PASSES_AUTO_QUICK_ADD'
}
